import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import ReactGA from 'react-ga'

import Ranges from '../../../../Components/ranges/Ranges'
import Footer from '../../Footer'

import { postPreferredTimes } from '../../../../api/api'
import { Plann3rStore } from '../../../../store/types'

const RangeStep: FC = () => {
  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.onboarding.rangestep,
  )
  const { preferred_times } = useSelector((state: Plann3rStore) => state.settings)

  ReactGA.event({
    category: 'Onboarding',
    action: 'Step 5',
  })

  return (
    <div className="onboarding_box">
      <div className="onboarding_content rangestep">
        <h2 className="title has-text-centered">{strings.title}</h2>
        <p className="step-description-string has-text-centered">
          {strings.explanation}
        </p>
        <div className="flex justify-center">
          <Ranges ranges={preferred_times} save={(preferred_times) => postPreferredTimes({
            preferred_times: JSON.stringify(preferred_times),
          })} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default RangeStep
